var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCirclesLightBlue = function SvgCirclesLightBlue(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 26",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 17,
    y: 1.5,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#021126"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 9,
    y: 3.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#0B3773"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2,
    y: 7.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1E78F5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCirclesLightBlue);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC42IiB4PSIxNyIgeT0iMS41IiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiByeD0iMy41IiBmaWxsPSIjMDIxMTI2Ii8+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iOSIgeT0iMy41IiB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHJ4PSI2LjUiIGZpbGw9IiMwQjM3NzMiLz4KPHJlY3Qgb3BhY2l0eT0iMC42IiB4PSIyIiB5PSI3LjUiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcng9IjgiIGZpbGw9IiMxRTc4RjUiLz4KPC9zdmc+Cg==";